module.exports = __webpack_public_path__ + "img/hazmatsuit.74c0de12.png";